import type { WaterClass } from '../../data/waterClasses';
import type { PolygonWithHoles, Ring, Vec2 } from '../../geo/types';
import { fromRing, intersection } from '../../geo/clip';
import { pointInPolygon, polygonArea } from '../../geo/polygon';

export interface WaterAreaSource {
  readonly id: string;
  readonly polygon: PolygonWithHoles;
}

export interface WaterAreaClass extends WaterAreaSource {
  readonly cls: WaterClass;
}

// An area the city enclosure mostly holds is a basin of the town and takes its canal water; the meres
// and ponds outside are open country water of the same character as the IJ.
export function classifyWaterAreas(
  areas: readonly WaterAreaSource[],
  cityEnclosure: Ring
): readonly WaterAreaClass[] {
  const town = [fromRing(cityEnclosure)];
  return areas.map(({ id, polygon }) => {
    const inside = intersection([polygon], town).reduce(
      (sum, piece) => sum + polygonArea(piece),
      0
    );
    const cls: WaterClass = inside * 2 > polygonArea(polygon) ? 'canalWater' : 'ijWater';
    return { id, polygon, cls };
  });
}

export function areaClassAt(areas: readonly WaterAreaClass[], p: Vec2): WaterClass | null {
  return areas.find((area) => pointInPolygon(p, area.polygon))?.cls ?? null;
}
